var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22,
    r: 21,
    fill: "#0C1525",
    stroke: "url(#paint0_linear_9501_68769)",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9501_68769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 12H16.6667C14.3692 12 12.5 13.8692 12.5 16.1667V27.8333C12.5 30.1308 14.3692 32 16.6667 32H28.3333C30.6308 32 32.5 30.1308 32.5 27.8333V16.1667C32.5 13.8692 30.6308 12 28.3333 12ZM23.3333 26.1667V27C23.3292 28.09 21.6708 28.0892 21.6667 27V26.1667H21.4433C20.5542 26.1667 19.7242 25.6883 19.2783 24.9175C19.0475 24.5183 19.1842 24.0092 19.5817 23.7792C19.9808 23.5467 20.49 23.685 20.72 24.0825C20.8692 24.3408 21.1458 24.5 21.4425 24.5H23.3325C24.1633 24.5542 24.535 23.2083 23.6292 23.0333L21.095 22.6108C18.1767 22.07 18.805 17.8167 21.6658 17.8333V17C21.6708 15.91 23.3283 15.9108 23.3325 17V17.8333H23.5558C24.445 17.8333 25.275 18.3125 25.7208 19.0833C25.9517 19.4817 25.815 19.9908 25.4175 20.2217C25.0175 20.4525 24.5083 20.3158 24.2792 19.9175C24.13 19.66 23.8533 19.5008 23.5567 19.5008H21.6667C20.8358 19.4467 20.465 20.7925 21.37 20.9675L23.9042 21.39C26.8225 21.9308 26.1942 26.1842 23.3333 26.1675V26.1667Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9501_68769",
    x1: 2.5,
    y1: 64.5926,
    x2: 50.4216,
    y2: 59.8518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.150307,
    stopColor: "#FF0E46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336372,
    stopColor: "#E30036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548934,
    stopColor: "#FD264E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74141,
    stopColor: "#FF345D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928887,
    stopColor: "#FD0A46"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9501_68769"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 12,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.9dbf74680ba1ff81f8c2a52cc3bfe4c2.svg";
export { ForwardRef as ReactComponent };